import type { AnyRoute } from "@tanstack/react-router";
import type { BooksSearchSchema } from "./search";

import { createRoute } from "@tanstack/react-router";

import { preloadBooks } from "../../../app/books";
import { BooksPage } from "./page";
import { booksSearchSchema } from "./search";

export function buildBooksRoute(parentRoute: AnyRoute) {
  return createRoute({
    getParentRoute: () => parentRoute,
    path: "/books",
    validateSearch: booksSearchSchema,
    loaderDeps: ({ search }: { search: BooksSearchSchema }) => search,
    async loader({ deps }) {
      preloadBooks(deps);
    },
    component: BooksPage
  });
}
